import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy Paddle success page. Card checkout was removed, and the page's
 * email-keyed status poll plus its public magic-link resend let anyone probe
 * whether an address has an account here, so both are gone. Old links land on
 * the "under review" page instead; the email in the URL is dropped.
 */
export const Route = createFileRoute("/_public/bousala/success")({
  beforeLoad: () => {
    throw redirect({ to: "/bousala/pending", search: { product: "v1" } as any });
  },
  head: () => ({
    meta: [
      { title: "قيد المراجعة — Under review" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => null,
});
